import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Constants} from '../../common/constants';
import {FieldConfigName, FieldType} from '../../../models';
import {ControlDialogOptionsHelper} from '../control-dialog-options-helper';

@Component({
  selector: 'app-checkbox-input-dialog',
  templateUrl: './checkbox-radio-input-dialog.component.html',
  styleUrls: ['./checkbox-radio-input-dialog.component.scss'],
})
export class CheckboxRadioInputDialogComponent extends ControlDialogOptionsHelper implements OnInit {
  constants: any = Constants;
  editCheckBoxInputForm: UntypedFormGroup;
  choices: any[];
  status: boolean;
  control: FieldConfigName;
  formArray: UntypedFormArray;
  fieldsLimit: number;

  constructor(private formBuilder: UntypedFormBuilder,
              public dialogRef: MatDialogRef<CheckboxRadioInputDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    super();
    if (data) {
      this.control = data.control || this.control;
      this.fieldsLimit = (data.control.options.controlType === FieldType.TypeRadio
        ? this.constants.fieldsLimit.radioLimit
        : this.constants.fieldsLimit.checkboxLimit );
    }
  }

  ngOnInit(): void {
    this.validateFormBuilder();
    this.editProperty(this.control);
  }

  validateFormBuilder(): void {
    this.editCheckBoxInputForm = this.formBuilder.group({
      tooltip: ['', []],
      label: ['', []],
      placeholder: ['', []],
      isRequired: [false],
      horizontal: [false],
      options: ['', []],
    });
  }

  editProperty(control: any): void {
    this.status = control.options.isRequired;
    this.editCheckBoxInputForm.setValue({
      tooltip: control.options.tooltip,
      label: control.options.label,
      placeholder: control.options.placeholder,
      isRequired: control.options.isRequired,
      horizontal: control.options.horizontal,
      options: control.options.options,
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.editCheckBoxInputForm.invalid) {
      return;
    }
    this.dialogRef.close(this.editCheckBoxInputForm.value);
  }

  onChange(event: any, name: string): void {
    this.editCheckBoxInputForm.get(name).setValue(!!event.checked);
  }

  onUpdateChoiceList(choices: { key: string }[]) {
    const data = [];
    choices.forEach(
      (elt) => data.push({key: elt.key, value: false})
    );
    this.editCheckBoxInputForm.patchValue({options: data});
  }
}
